import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import './src/assets/scss/app.scss';
// gatsby-browser.js
export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};


// gatsby-ssr.js or gatsby-browser.js
// export const onClientEntry = () => {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker
//       .register('/firebase-messaging-sw.js')
//       .then((registration) => {
//         console.log('Service Worker registered:', registration);
//       })
//       .catch((err) => {
//         console.error('Service Worker registration failed:', err);
//       });
//   }
// };

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/firebase-messaging-sw.js')
//     .then((registration) => {
//       console.log('Service Worker registered:', registration);
//     })
//     .catch((err) => {
//       console.log('Service Worker registration failed:', err);
//     });
// }
